/**
 * Enum defining the data sources for agent tool configuration fields.
 * Each source maps to a specific UI component and data endpoint.
 */
export enum AgentConfigSource {
	/**
	 * Provisioned phone numbers for the tenant.
	 * UI: PhoneNumberField component
	 * Endpoint: GET /ai-agents/agents/provisioned-phones
	 */
	PROVISIONED_PHONES = 'provisioned_phones',

	/**
	 * Verified email domains for the tenant.
	 * UI: EmailFromField component (local@domain format)
	 * Endpoint: GET /email/domains
	 */
	VERIFIED_EMAIL_DOMAINS = 'verified_email_domains',

	/**
	 * Users in the system (for assignment, transfer, etc.)
	 * UI: UserSelector component
	 * Endpoint: GET /users
	 */
	USERS = 'users',

	/**
	 * AI Agents in the system (for transfer scenarios)
	 * UI: AgentSelector component
	 * Endpoint: GET /ai-agents/agents
	 */
	AGENTS = 'agents',

	/**
	 * Email templates for the tenant.
	 * UI: SelectSearch component with template list
	 * Endpoint: GET /email/templates
	 */
	EMAIL_TEMPLATES = 'email_templates',

	/**
	 * Simple text input field.
	 * UI: Standard text Input component
	 * No endpoint - just a plain text field
	 */
	TEXT = 'text',

	/**
	 * Transfer target phone numbers with labels.
	 * UI: List editor with phone number + label pairs (add/remove rows)
	 * No endpoint - user-defined list stored as Array<{ number: string, label: string }>
	 */
	TRANSFER_TARGETS = 'transfer_targets',

	/**
	 * IVR menu options for DTMF-driven routing.
	 * UI: List editor with DTMF key, label, phrase, action type, and action config per row.
	 * No endpoint - user-defined list stored as Array<IvrMenuOption>
	 */
	IVR_MENU = 'ivr_menu',
}
